import useAPI from '../../hooks/useAPI';
import useIdle from '../../hooks/useIdle';
import useUser from '../../hooks/useUser';

const IdleTimer = () => {
  const { isAuth } = useUser();
  const { updateLastActivity } = useAPI();

  // Check if user is idle
  useIdle(isAuth, updateLastActivity, process.env.REACT_APP_LAB_IDLE_TIMER);
  return null;
};

export default IdleTimer;
